import React, { useEffect, useState } from 'react';
import { Box, Theme } from '@material-ui/core';
import Menu from '@material-ui/core/Menu';
import MenuItem from '@material-ui/core/MenuItem';
import makeStyles from '@material-ui/core/styles/makeStyles';
import { useTranslation } from 'react-i18next';
import { fetchLanguages } from '../../../api/language';
import { DictionaryDto } from '../../../api/dictionary';
import { languageMappings } from '../../../constants';

const useStyles = makeStyles((theme: Theme) => ({
    language: {
        color: '#383b5b',
        cursor: 'pointer',
        marginLeft: theme.spacing(2),
        fontSize: '18px',
    },
}));

const Language = () => {
    const { i18n } = useTranslation();
    const classes = useStyles();
    const getLanguage = () => i18n.language || window.localStorage.i18nextLng;
    const getLanguageKey = () => {
        let result = '';

        languageMappings.forEach((value, key) => {
            if (value === getLanguage()) {
                result = key;
                return;
            }
        });

        return result;
    };

    const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
    const [language, setLanguage] = useState(getLanguageKey());
    const [languages, setLanguages] = useState<DictionaryDto[]>([]);

    const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
        setAnchorEl(event.currentTarget);
    };

    const handleClose = () => {
        setAnchorEl(null);
    };

    const handleChangeLanguage = (lang: string) => {
        const langCode = languageMappings.get(lang);
        if (langCode === getLanguage()) {
            handleClose();
            return;
        }

        setLanguage(lang);
        i18n.changeLanguage(langCode || 'ru');
        handleClose();
    };

    useEffect(() => {
        (async function () {
            const data = await fetchLanguages();
            setLanguages(data.content);
        })();
    }, []);

    return (
        <Box>
            <Box className={classes.language} onClick={handleClick}>
                {language}
            </Box>
            <Menu
                style={{
                    top: '30px',
                }}
                id="language-menu"
                anchorEl={anchorEl}
                keepMounted
                open={Boolean(anchorEl)}
                onClose={handleClose}
            >
                {languages.map((item, index) => (
                    <MenuItem key={index} onClick={() => handleChangeLanguage(item.code)}>
                        {item.code}
                    </MenuItem>
                ))}
            </Menu>
        </Box>
    );
};

export default Language;
